import 'regenerator-runtime/runtime.js';
import '@babel/polyfill';
import 'whatwg-fetch';
import React from 'react';
import ReactDom from 'react-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import HeadNav from './components/HeadNav';
import InterviewSlider from './components/InterviewSlider';
// import IndexHeader from './components/IndexHeader';

const { path } = document.body.dataset;

ReactDom.render(<HeadNav path={path} />, document.getElementById('headNav'));
ReactDom.render(<InterviewSlider />, document.getElementById('interviewSlider'));
// ReactDom.render(<IndexHeader />, document.getElementById('indexHeader'));

gsap.registerPlugin(ScrollTrigger);
const markers = false;

document.addEventListener('DOMContentLoaded', () => {
  // gsap.to('.advantageWrap', {
  //   opacity: 1,
  //   y: 0,
  //   duration: 1,
  //   scrollTrigger: {
  //     trigger: '.advantageWrap',
  //     start: 'top 70%',
  //     markers,
  //   },
  // });

  gsap.to('.environmenrBg', {
    x: '-100vw',
    duration: 1,
    scrollTrigger: {
      trigger: '.environmenrBg',
      start: 'top 70%',
      markers,
    },
  });

  gsap.to('.environmentPic', {
    x: '0',
    duration: 1,
    scrollTrigger: {
      trigger: '.environmentPic',
      start: 'top 70%',
      markers,
    },
  });

  gsap.to('.knowLink', {
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: '.knowLink',
      start: 'top 70%',
      markers,
    },
  });
});
